import React, { useContext, useEffect } from "react";
// react component used to create charts
import SweetAlert from "react-bootstrap-sweetalert";
// react component that creates a form divided into multiple steps
import ReactWizard from "react-bootstrap-wizard";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "react-bootstrap";

import { useGuestContext } from '../../../../contexts/GuestContext';

import RegistrationWizardContent from "./RegistrationWIzardContent";
import { WizardProvider, useWizard } from './WizardContext';
import { Oval } from 'react-loader-spinner';

function RegistrationWizard() {
  const { loading, setLoading } = useGuestContext();
  return (
    <>
      {loading && (
        <div className="overlay ">
          <div className="loader d-flex flex-column align-items-center justify-content-center">
            <Oval color="red" height={120} width={120} className="d-block mb-3" />
            <h4 className="loading-text">Loading...</h4>
          </div>
        </div>
      )}
      <WizardProvider>
        <Container fluid>
          <Row>
            <Col className="ml-auto mr-auto" md="8">
              <RegistrationWizardContent />
            </Col>
          </Row>
        </Container>
      </WizardProvider>
    </>
  );
}

export default RegistrationWizard;
